import { navigate } from "gatsby"

import { marketingClient } from "@trueskin-web/apis"
import { CdnImage } from "@trueskin-web/components"
import { Routes, Trans } from "@trueskin-web/translations"

import Services from "../../../components/payment/overview/services"
import Voucher from "../../../components/payment/voucher"
import VoucherMessage from "../../../components/payment/voucher-message"

const Overview = ({
  presetId,
  image,
  productTitle,
  services,
  totalPrice,
  totalWithoutDiscounts,
  instalmentsCount,
  perInstalmentPrice,
  instalmentsTotalPrice,
  isSubscription,
  voucher,
}) => {
  const hasDiscount = totalWithoutDiscounts > totalPrice

  const onEditClick = () => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.CHANGE_PLAN,
    })

    return navigate(Routes.App.Start.ChoosePlan.url)
  }

  return (
    <div data-component-name="PaymentOverview" data-preset-id={presetId}>
      <div
        sx={{
          p: 5,
          border: "1px",
          borderColor: "grey",
        }}
      >
        <CdnImage
          src={image}
          alt={productTitle}
          sx={{ maxWidth: 220, mx: "auto", display: "block" }}
        />

        {services?.length > 0 ? (
          <Services services={services} onEditClick={onEditClick} />
        ) : null}
        <Voucher />

        <div
          sx={{
            mt: 4,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span sx={{ fontSize: 3 }}>
            <Trans i18nKey="Payment.Overview.total" />
          </span>
          {hasDiscount && (
            <del
              sx={{
                ml: "auto",
                mr: 2,
                fontSize: 4,
                fontWeight: "normal",
                color: "textDark",
              }}
            >
              {totalWithoutDiscounts}
            </del>
          )}
          <span
            data-testid="web-portal-summary-total-price"
            sx={{
              fontSize: 3,
            }}
          >
            {totalPrice}
          </span>
        </div>
      </div>

      {instalmentsCount > 1 ? (
        <div sx={{ mt: 4, fontSize: 1, color: "textDark" }}>
          <Trans
            i18nKey="Payment.Overview.twoMonthsPackageDisclaimer"
            values={{
              totalPrice: instalmentsTotalPrice,
              perMonthPrice: perInstalmentPrice,
              count: instalmentsCount,
            }}
          />
        </div>
      ) : null}
      <VoucherMessage
        voucher={voucher}
        error={!isSubscription ? "VOUCHER_NOT_AUTOREFILL" : null}
      />
    </div>
  )
}

export default Overview
